<template>
  <section class="layout-container"
           :id="info.id">
    <img v-if="info.background"
         class="bg"
         :src="
        info.background +
        '&imageMogr2/thumbnail/2000x2000/format/' +
        $pic_type +
        '/interlace/1'
      "
         alt="" />
    <div v-else
         class="default-box"></div>
    <!-- 编辑模式 -->
    <template v-if="isEditMode">
      <div>
        <!-- <video class="video editMode"
               :poster="
            info.poster +
            '&imageMogr2/thumbnail/2000x2000/format/' +
            $pic_type +
            '/interlace/1'
          "
               :src="info.src"
               :style="style"
               x5-playsinline
               playsinline
               webkit-playsinle
               :controls="info.control"
               :autoplay="info.autoplay"
               :width="info.width + '%'"
               :height="info.height + '%'" /> -->
        <section class="wrapper"
                 :style="{
                 width: info.width + '%',
                 height: info.height + '%',
                 top: info.style.top + '%',
                 left: info.style.left + '%',
                 position: 'absolute'
               }">
          <video :id="id"
                 class="video-js vjs-big-play-centered vjs-fluid video editMode"
                 preload="auto"
                 webkit-playsinline
                 playsinline
                 x5-playsinline
                 x-webkit-airplay="allow"
                 :poster="info.poster +
            '&imageMogr2/thumbnail/2000x2000/format/' +
            $pic_type +
            '/interlace/1'">
            <source :src="info.src" />
          </video>
        </section>
      </div>
    </template>

    <!-- 渲染模式 -->
    <template v-else>
      <!-- <video class="video"
             :poster="
          info.poster +
          '&imageMogr2/thumbnail/2000x2000/format/' +
          $pic_type +
          '/interlace/1'
        "
             :src="info.src"
             :style="style"
             x5-playsinline
             playsinline
             webkit-playsinle
             :controls="info.control"
             :autoplay="info.autoplay"
             :width="info.width + '%'"
             :height="info.height + '%'" /> -->
      <section class="wrapper"
               :style="{
                 width: info.width + '%',
                 height: info.height + '%',
                 top: info.style.top + '%',
                 left: info.style.left + '%',
                 position: 'absolute'
               }">
        <video :id="id"
               class="video-js vjs-big-play-centered video"
               preload="auto"
               webkit-playsinline
               playsinline
               x5-playsinline
               x-webkit-airplay="allow"
               :poster="info.poster +
            '&imageMogr2/thumbnail/2000x2000/format/' +
            $pic_type +
            '/interlace/1'">
          <source :src="info.src" />
        </video>
      </section>
    </template>
  </section>
</template>
<script>
export default {
  /******************************************
  ** 视频组件
  * @description 视频组件
  * @author stone
  *****************************************
  info            Object             属性样式数据
  isEditMode      Boolean            是否编辑模式
  *****************************************/
  name: 'textLayout',
  components: {},
  props: {
    info: {
      type: Object
    },
    isEditMode: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      control: true
    }
  },
  watch: {
    'info.width' (n, o) {
      console.log('-----', n)
    },
    'info.src' (n, o) {
      console.log('-------', n, o)
      this.player.src(this.info.src)
      this.player.load()
    },
    'info.control' (n, o) {
      // this.player.dispose()
      this.player.options_.control = n
      this.init()
      this.player.load()
    },
    'info.autoplay' (n, o) {
      // this.player.dispose()
      this.player.options_.autoplay = n
      this.init()
      this.player.load()
    }
  },
  computed: {
    id () {
      return 'p_' + parseInt(Math.random() * 1000)
    },
    style () {
      return {
        top: this.info.style.top + '%',
        left: this.info.style.left + '%'
      }
    }
  },
  methods: {
    init () {
      const _this = this
      this.player = this.$video(
        document.getElementById(this.id),
        {
          // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API
          controls: this.info.control,
          // 自动播放属性,muted:静音播放
          autoplay: this.info.autoplay,
          // 建议浏览器是否应在<video>加载元素后立即开始下载视频数据
          preload: 'auto',
          controlBar: {
            playToggle: true
          }
        },
        function () {
          this.on('error', function () {
            _this.player.errorDisplay.close() // 将错误信息不显示
            // 自定义显示方式
          })
        }
      )
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
.layout-container {
  width: 100%;
  position: relative;

  ::v-deep .video-js {
    width: 100%;
    height: 100%;
    background: transparent;
  }
  ::v-deep .vjs-poster {
    background-size: cover;
  }

  .default-box {
    min-height: 200px;
  }

  .bg {
    width: 100%;
    display: block;
    transform: scale3d(1, 1, 1);
  }

  .video {
    position: absolute;
    top: 0;
    left: 0;
  }
  .editMode {
    border: 1px solid transparent;
    box-sizing: border-box;
    &:hover {
      cursor: move;
      border: 1px solid #2354f2;
    }
  }
}
</style>
